<template>
  <div v-if="season" :class="$style.container">
    <div>
      <b>Отопительный сезон {{ season.start_year }} - {{ season.start_year + 1 }}</b>:
      {{ formatDate(season.period_start_month) }} - {{ formatDate(season.period_end_month) }}
    </div>
    <vs-button color="success" @click="onOpenSettings">Настроить</vs-button>
    <vs-button type="flat" @click="onOpenHistory">История</vs-button>
  </div>
</template>

<script>
import formatDate from "@/client/helpers/formatDate";

export default {
  name: "HeatSeasonSettings",
  data() {
    return {
      season: null,
    };
  },

  computed: {
    selectedBuildingId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
  },
  methods:  {
    formatDate,

    loadSeason() {
      const { selectedBuildingId } = this;
      this.$http.get(`heat/season/current/${selectedBuildingId}`, { params: { buildings_id: this.selectedBuildingId } })
        .then(( { data: { season } } ) => this.season = season);
    },

    onOpenSettings() {
      const { season } = this;
      this.$modal.open({
        overflowHeight: true,
        title:          `Настройка отопительного сезона ${this.season.start_year} - ${this.season.start_year + 1}`,
        component:      () => import('@/components/HeatSeasonEditPopup'),
        componentProps: {
          season,
        },
      }).result.then(
        () => {
          this.loadSeason();
        },
        () => {},
      );
    },

    onOpenHistory() {
      this.$modal.open({
        title:          `История дат отопительного сезона`,
        component:      () => import('@/components/HeatSeasonHistoryPopup'),
        componentProps: {
          buildingId: this.selectedBuildingId,
        },
      });
    },
  },
  mounted() {
    this.loadSeason();
  },

  watch: {
    selectedBuildingId() {
      this.loadSeason();
    },
  },
};
</script>

<style lang="scss" module>
.container {
  padding: 0 1.5rem;
  display: flex;
  align-items: center;
  margin: 0 -.25em;

  > * {
    margin: 0 .25em;
  }
}
</style>
